<template>
  <!-- 日付選択ダイアログ -->
  <v-dialog
    v-model="dialogModel"
    max-width="1200"
    persistent
  >
    <v-card>
      <v-card-title>
        <span style="color: #0074BA">曜日一括選択</span>
      </v-card-title>
      <v-card-text>
        <v-row justify="center" class="mb-4">
          <v-col cols="auto">
            <v-btn
              :color="selectedDayOfWeeks.includes(0) ? 'primary' : ''"
              :outlined="!selectedDayOfWeeks.includes(0)"
              @click="toggleDayOfWeek(0)"
              class="mx-1"
            >
              日
            </v-btn>
            <v-btn
              :color="selectedDayOfWeeks.includes(1) ? 'primary' : ''"
              :outlined="!selectedDayOfWeeks.includes(1)"
              @click="toggleDayOfWeek(1)"
              class="mx-1"
            >
              月
            </v-btn>
            <v-btn
              :color="selectedDayOfWeeks.includes(2) ? 'primary' : ''"
              :outlined="!selectedDayOfWeeks.includes(2)"
              @click="toggleDayOfWeek(2)"
              class="mx-1"
            >
              火
            </v-btn>
            <v-btn
              :color="selectedDayOfWeeks.includes(3) ? 'primary' : ''"
              :outlined="!selectedDayOfWeeks.includes(3)"
              @click="toggleDayOfWeek(3)"
              class="mx-1"
            >
              水
            </v-btn>
            <v-btn
              :color="selectedDayOfWeeks.includes(4) ? 'primary' : ''"
              :outlined="!selectedDayOfWeeks.includes(4)"
              @click="toggleDayOfWeek(4)"
              class="mx-1"
            >
              木
            </v-btn>
            <v-btn
              :color="selectedDayOfWeeks.includes(5) ? 'primary' : ''"
              :outlined="!selectedDayOfWeeks.includes(5)"
              @click="toggleDayOfWeek(5)"
              class="mx-1"
            >
              金
            </v-btn>
            <v-btn
              :color="selectedDayOfWeeks.includes(6) ? 'primary' : ''"
              :outlined="!selectedDayOfWeeks.includes(6)"
              @click="toggleDayOfWeek(6)"
              class="mx-1"
            >
              土
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-date-picker
              v-model="selectedDates"
              :min="minCollectedDate"
              :max="maxCollectedDate"
              :picker-date="pickerDate1"
              :day-format="date => new Date(date).getDate()"
              multiple
              locale="ja"
              color="primary"
              full-width
              no-title
              show-adjacent-months
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-date-picker
              v-model="selectedDates"
              :min="minCollectedDate"
              :max="maxCollectedDate"
              :picker-date="pickerDate2"
              :day-format="date => new Date(date).getDate()"
              multiple
              locale="ja"
              color="primary"
              full-width
              no-title
              show-adjacent-months
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-date-picker
              v-model="selectedDates"
              :min="minCollectedDate"
              :max="maxCollectedDate"
              :picker-date="pickerDate3"
              :day-format="date => new Date(date).getDate()"
              multiple
              locale="ja"
              color="primary"
              full-width
              no-title
              show-adjacent-months
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeDateSelectDialog"
        >
          閉じる
        </v-btn>
        <v-btn
          @click="clearSelection"
          color="primary"
        >
          クリア
        </v-btn>
        <v-btn
          color="primary"
          @click="applySelectedDates"
        >
          反映
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- /日付選択ダイアログ -->
</template>

<script>
export default {
  name: 'CollectedSelectedDialog',
  props: {
    /**
     * ダイアログの表示状態
     */
    enableDialog: {
      type: Boolean,
      default: false,
    },
    /**
     * 回収日の最小日付
     */
    minCollectedDate: {
      type: String,
      required: true,
    },
    /**
     * 回収日の最大日付
     */
    maxCollectedDate: {
      type: String,
      required: true,
    },
    /**
     * 初期選択日付
     */
    initialSelectedDates: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedDates: [],
      selectedDayOfWeeks: [],
      pickerDate1: '',
      pickerDate2: '',
      pickerDate3: '',
    }
  },
  computed: {
    dialogModel: {
      get() {
        return this.enableDialog
      },
      set(value) {
        if (!value) {
          this.closeDateSelectDialog()
        }
      }
    }
  },
  watch: {
    enableDialog(newVal) {
      if (newVal) {
        this.openDateSelectDialog()
      }
    }
  },
  methods: {
    /**
     * 日付選択ダイアログを開く
     */
    openDateSelectDialog() {
      // 既存の選択日付を読み込む
      this.selectedDates = this.initialSelectedDates ? [...this.initialSelectedDates] : []
      this.selectedDayOfWeeks = []
      this.pickerDate1 = this.$dayjs().format('YYYY-MM')
      this.pickerDate2 = this.$dayjs().add(1, 'month').format('YYYY-MM')
      this.pickerDate3 = this.$dayjs().add(2, 'months').format('YYYY-MM')
    },

    /**
     * 日付選択ダイアログを閉じる
     */
    closeDateSelectDialog() {
      this.selectedDates = []
      this.selectedDayOfWeeks = []
      this.$emit('closeCallback')
    },

    /**
     * 曜日ボタンのトグル
     * @param {number} dayIndex - 曜日のインデックス (0: 日曜, 1: 月曜, ..., 6: 土曜)
     */
    toggleDayOfWeek(dayIndex) {
      const index = this.selectedDayOfWeeks.indexOf(dayIndex)
      if (index > -1) {
        // 曜日選択を解除
        this.selectedDayOfWeeks.splice(index, 1)
        // その曜日の日付を選択から削除
        this.removeDatesByDayOfWeek(dayIndex)
      } else {
        // 曜日を選択
        this.selectedDayOfWeeks.push(dayIndex)
        // その曜日の日付を選択に追加
        this.addDatesByDayOfWeek(dayIndex)
      }
    },

    /**
     * 指定された曜日の日付を削除
     * @param {number} dayIndex - 曜日のインデックス (0: 日曜, 1: 月曜, ..., 6: 土曜)
     */
    removeDatesByDayOfWeek(dayIndex) {
      const today = this.$dayjs()
      const minDate = this.$dayjs(this.minCollectedDate)
      const startDate = today.isAfter(minDate) ? today : minDate
      const endDate = this.$dayjs(this.maxCollectedDate).isBefore(this.$dayjs().add(3, 'months'))
        ? this.$dayjs(this.maxCollectedDate)
        : this.$dayjs().add(3, 'months')

      const datesToRemove = []
      let currentDate = startDate

      while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, 'day')) {
        if (currentDate.day() === dayIndex) {
          datesToRemove.push(currentDate.format('YYYY-MM-DD'))
        }
        currentDate = currentDate.add(1, 'day')
      }

      // 該当する曜日の日付を削除
      this.selectedDates = this.selectedDates.filter(date => !datesToRemove.includes(date))
    },

    /**
     * 指定された曜日の日付を追加
     * @param {number} dayIndex - 曜日のインデックス (0: 日曜, 1: 月曜, ..., 6: 土曜)
     */
    addDatesByDayOfWeek(dayIndex) {
      const today = this.$dayjs()
      const minDate = this.$dayjs(this.minCollectedDate)
      const startDate = today.isAfter(minDate) ? today : minDate
      const endDate = this.$dayjs(this.maxCollectedDate).isBefore(this.$dayjs().add(2, 'months').endOf('month'))
        ? this.$dayjs(this.maxCollectedDate)
        : this.$dayjs().add(2, 'months').endOf('month')

      const datesToAdd = []
      let currentDate = startDate

      while (currentDate.isBefore(endDate) || currentDate.isSame(endDate, 'day')) {
        if (currentDate.day() === dayIndex) {
          const dateString = currentDate.format('YYYY-MM-DD')
          if (!this.selectedDates.includes(dateString)) {
            datesToAdd.push(dateString)
          }
        }
        currentDate = currentDate.add(1, 'day')
      }

      // 既存の選択に追加
      this.selectedDates = [...new Set([...this.selectedDates, ...datesToAdd])].sort()
    },

    /**
     * 選択をクリア
     */
    clearSelection() {
      this.selectedDates = []
      this.selectedDayOfWeeks = []
    },

    /**
     * 選択した日付を反映
     */
    applySelectedDates() {
      // ソート済みの日付配列を取得（空の配列でも送信する）
      const sortedDates = [...this.selectedDates].sort()

      // 親コンポーネントに選択日付を返す
      this.$emit('applyCallback', sortedDates)
      this.closeDateSelectDialog()
    },
  }
}
</script>

<style scoped>
/* カレンダーの月移動ボタン（<>）を非表示 */
:deep(.v-date-picker-header > button) {
  display: none !important;
}

/* カレンダーのタイトル（月年表示）をクリック不可に */
:deep(.v-date-picker-header__value) {
  pointer-events: none !important;
  cursor: default !important;
}

/* 曜日ヘッダーの色（日曜始まりの場合） */
:deep(.v-date-picker-table thead tr th:nth-child(1)) {
  color: #F44336 !important; /* 日曜日を赤に */
}

:deep(.v-date-picker-table thead tr th:nth-child(7)) {
  color: #2196F3 !important; /* 土曜日を青に */
}

/* 日曜日の日付の色 */
:deep(.v-date-picker-table tbody tr td:nth-child(1) button) {
  color: #F44336 !important;
}

:deep(.v-date-picker-table tbody tr td:nth-child(1) button .v-btn__content) {
  color: #F44336 !important;
}

:deep(.v-date-picker-table tbody tr td:nth-child(1) button:not(.v-btn--active)) {
  color: #F44336 !important;
}

:deep(.v-date-picker-table tbody tr td:nth-child(1) button.v-btn--outlined:not(.v-btn--active)) {
  color: #F44336 !important;
}

/* 土曜日の日付の色 */
:deep(.v-date-picker-table tbody tr td:nth-child(7) button) {
  color: #2196F3 !important;
}

:deep(.v-date-picker-table tbody tr td:nth-child(7) button .v-btn__content) {
  color: #2196F3 !important;
}

:deep(.v-date-picker-table tbody tr td:nth-child(7) button:not(.v-btn--active)) {
  color: #2196F3 !important;
}

:deep(.v-date-picker-table tbody tr td:nth-child(7) button.v-btn--outlined:not(.v-btn--active)) {
  color: #2196F3 !important;
}

/* 前月・翌月の選択日付の色を灰色に（インラインスタイルを上書き） */
:deep(.v-date-picker-table .v-btn--active.v-btn--disabled) {
  background-color: #9E9E9E !important;
}

/* 前月・翌月の非選択日付（選択解除後）の背景を白に
:deep(.v-date-picker-table .v-btn--disabled:not(.v-btn--active)) {
  background-color: transparent !important;
} */

/* 選択解除した日付の背景を白に */
:deep(.v-date-picker-table .v-btn:not(.v-btn--active)) {
  background-color: white !important;
}
:deep(.v-date-picker-table .v-btn:not(.v-btn--active)::before) {
  opacity: 0 !important;
  background-color: transparent !important;
}
</style>
